export default () => {
  // disable turbo links on all forms
  document.querySelectorAll('form').forEach((f) => f.dataset.turbo = 'false');

  // https://github.com/hotwired/turbo/issues/539
  // Do not use turbolinks on any links with a hash only (breaks `:target` otherwise)
  document.querySelectorAll('a').forEach(function (el) {
    if (el?.getAttribute('href')?.startsWith('#')) {
      el.dataset.turbo = 'false';
    }
  });

  // https://github.com/turbolinks/turbolinks/issues/248
  // Reason: Always scroll (instantly) to top if navigating to site / clicking on a link
  document.addEventListener('turbo:render', function () {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  });
}
